import { KSpan } from "kahuna-base-react-components"
import { TABLE_COLUMN_TYPE } from "../../../../../constants"
import { TableColumn, TrackEarning } from "../../../../../types"
import TruncatedListWithTooltip from "../../../playlists/components/TruncatedListWithTooltip"
import { lang } from "../../../../../constants/languages"
import { formatUsd, getPercentage } from "../../../../../utility"
//@ts-ignore
import ArrowUpIcon from "../../../../../assets/analytics_icons/arrow-up-green.svg"
//@ts-ignore
import ArrowDownIcon from "../../../../../assets/analytics_icons/arrow-down-red.svg"

const renderChange = (percentChange: number | undefined) => {
  if (!percentChange) return null

  return (
    <div className="flex flex-row items-center gap-[0px] pb-[1px]">
      <img src={percentChange > 0 ? ArrowUpIcon : ArrowDownIcon} alt="change-icon" height={14} width={14} />
      <KSpan
        text={`${Number(percentChange.toFixed(0)).toLocaleString("en-US")}%`}
        color={percentChange > 0 ? "#318D18" : "#D02E20"}
        fontSize={11}
        lineHeight="14px"
      />
    </div>
  )
}

const trackTitle: TableColumn = {
  header: lang.royalties.earnings.track,
  headerStyle: {
    textAlign: "left",
    width: "40%"
  },
  type: TABLE_COLUMN_TYPE.FUNCTION,
  render: (row: TrackEarning) => {
    return (
      <div className="flex w-max flex-col gap-1p">
        <div className="flex items-center">
          <KSpan text={row?.track?.title || "-"} color="#000" fontWeight={500} fontSize={13} />
        </div>
        <TruncatedListWithTooltip
          itemList={row?.track?.artistList?.map((artist) => artist.name) || []}
          visibleItemCount={3}
          breakPointInPx={1200}
          smallScreenVisibleItemCount={2}
          title={""}
        />
      </div>
    )
  }
}

const isrc: TableColumn = {
  header: "ISRC",
  headerStyle: {
    textAlign: "left",
    width: "20%"
  },
  type: TABLE_COLUMN_TYPE.FUNCTION,
  render: (row: TrackEarning) => {
    return (
      <div className="flex">
        <div className="rounded-[4px] bg-[#F7F7F7] flex items-center px-1.5 py-1 w-auto">
          <div className="flex flex-row items-center pr-1">
            <KSpan
              text={row?.isrc || "-"}
              color="#111"
              fontSize={12}
              fontWeight={500}
              lineHeight="16px"
              letterSpacing="0.22px"
            />
          </div>
        </div>
      </div>
    )
  }
}

const earnings: TableColumn = {
  header: lang.royalties.earnings.earnings,
  headerStyle: {
    textAlign: "left",
    width: "20%"
  },
  type: TABLE_COLUMN_TYPE.FUNCTION,
  render: (row: TrackEarning) => {
    const percentChange = getPercentage(row?.previousNetUsd, row?.totalNetUsd) ?? undefined

    return (
      <div className="flex w-max flex-row gap-1">
        <KSpan text={formatUsd(row?.totalNetUsd || 0)} color="#111" fontSize={13} fontWeight={500} />
        {renderChange(percentChange)}
      </div>
    )
  }
}

const streams: TableColumn = {
  header: lang.royalties.earnings.streams,
  headerStyle: {
    textAlign: "left",
    width: "20%"
  },
  type: TABLE_COLUMN_TYPE.FUNCTION,
  render: (row: TrackEarning) => {
    const percentChange = getPercentage(row?.previousStream, row?.stream) ?? undefined

    return (
      <div className="flex w-max flex-row gap-1">
        <KSpan text={(row?.stream || 0).toLocaleString("en-US")} color="#111" fontSize={13} />
        {renderChange(percentChange)}
      </div>
    )
  }
}

const earningsTableColumns = (): TableColumn[] => [trackTitle, isrc, earnings, streams]

export default earningsTableColumns
